import { takeLatest, put } from 'redux-saga/effects';
import { apiCall } from './network';
import {
  GET_AIRCRAFTS,
  UPDATE_AIRCRAFT,
  ADD_NEW_AIRCRAFT,
  DELETE_AIRCRAFT
} from '../names';
import { AnyAction } from 'redux';
import {
  setAircrafts,
} from 'reduxStore/actions/aircraft';
import { toast } from 'react-toastify';
import { t } from 'I18n';
import * as R from 'ramda';

const URL = '/api/aircraft-positions';

function* getAircrafts(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}${action.payload}`;

  try {
    const res = yield apiCall(url, 'GET', headers);
    const response = yield res.json();
    yield put(setAircrafts(response));
  } catch (error) {
    console.error(error);
  }
}

function* updateAircraft(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}/${action.payload.id}`;
  try {
    yield apiCall(url, 'PUT', headers, JSON.stringify(action.payload.data));
    action.payload.onSuccess();
    toast.success(t('int.aircraft-updated-successfully'));
  } catch (error) {
    const err = yield error.json();
    const errors = Object.keys(err.fieldErrors);
    errors.forEach(key => {
      toast.error(
        `${t(
          R.pathOr('int.an-error-has-occurred', ['fieldErrors', key], err)
        )} ${t(key)}`
      );
    });
  }
}

function* addNewAircraft(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}`;

  try {
    yield apiCall(url, 'POST', headers, JSON.stringify(action.payload));
    action.payload.onSuccess();
    toast.success(t('int.aircraft-added-successfully'));
  } catch (error) {
    const err = yield error.json();
    const errors = Object.keys(err.fieldErrors);
    errors.forEach(key => {
      toast.error(
        `${t(
          R.pathOr('int.an-error-has-occurred', ['fieldErrors', key], err)
        )} ${t(key)}`
      );
    });
  }
}

function* deleteAircraft(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}/${action.payload.id}`;

  try {
    yield apiCall(url, 'DELETE', headers);
    action.payload.onSuccess();
    toast.success(t('int.aircraft-deleted-successfully'));
  } catch (error) {
    const err = yield error.json();
    if (err?.error) {
      toast.error(t(err.error));
    }
  }
}
function* aircraftWatcher() {
  yield takeLatest(GET_AIRCRAFTS, getAircrafts);
  yield takeLatest(UPDATE_AIRCRAFT, updateAircraft);
  yield takeLatest(ADD_NEW_AIRCRAFT, addNewAircraft);
  yield takeLatest(DELETE_AIRCRAFT, deleteAircraft);
}

export default aircraftWatcher;
